const leaders = [
  {
    img: '/img/leader-slide2.png',
    name: 'Vijay Akasapu',
    job: 'CEO',
    text: 'A pioneer in modern threat detection, Vijay Akasapu has spent 20+ years shaping the security landscape. As a founding member of Mandiant, he helped pioneer the first generation of EDR technology. Drawing on deep expertise from his time at Foundstone and FireEye, Vijay leads with a unique convergence of R&D innovation and service delivery, focused on solving complex risk challenges for the modern enterprise.',
    style: {

    }
  },
  {
    img: '/img/julio.png',
    name: 'Julio Escobar',
    job: 'CFO',
    text: 'Three decades of experience as an innovator, executive, entrepreneur and policy maker. Founder and co-founder of two technology companies. Believes in talent and motivation to drive innovation.',
    style: {
      opacity: 0.8
    }
  },
  {
    img: '/img/leader-slide5.png',
    name: 'Eric Cornelius',
    job: 'CTO',
    text: 'Two decades of hands-on engineering experience and technical leadership working in digital media, finance, and cybersecurity domains.',
    style: {
      backgroundPositionY: 'center'
    }
  }
];

export default leaders;

